import { defineEvent } from '../types/event';
export var COUPON_MODAL_DID_NOT_BOUNCE = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
